module.exports = __webpack_public_path__ + "media/audio3.c40677c6.mp3";